const MAX_COHORT_LABEL_ROW_LENGTH = 10;
const MAX_COHORT_LABEL_ROW_COUNT = 3;

// Array of labels allows label to be split into multiple lines
export const formatTopCohortLabel = (label: string) => {
	// split label into array of words or multiple words up to 9 characters total, with whitespace trimmed
	const words = splitLabelWordsIfNecessary(label.split(" "));

	// if label is one word, return as is else format label
	if (words.length === 1) {
		return label;
	} else {
		return formatMultiWordCohortLabel(words);
	}
};

// if any word is longer than MAX characters, split into multiple words
export const splitLabelWordsIfNecessary = (words: string[]) => {
	for (let index = 0; index < words.length; index++) {
		const word = words[index];
		if (word.length >= MAX_COHORT_LABEL_ROW_LENGTH) {
			words[index] = word.slice(0, MAX_COHORT_LABEL_ROW_LENGTH);
			words.splice(index + 1, 0, word.slice(MAX_COHORT_LABEL_ROW_LENGTH));
		}
	}

	return words;
};

//split the multiple words into lines that
// if any label is longer than MAX characters or MAX lines, truncate and add ellipsis
export const formatMultiWordCohortLabel = (words: string[]) => {
	let lines: string[] = [];
	let line = "";

	words.forEach((word) => {
		if (line.length + word.length <= 9) {
			// if line is less than 9 characters, add word to line
			line += word + " ";
		} else {
			// if line is 9 characters, push line to lines array and start new line
			line !== "" && lines.push(line.trim());
			line = word + " ";
		}
	});
	lines.push(line.trim());

	// if more than 3 lines, truncate and add ellipsis
	if (lines.length > MAX_COHORT_LABEL_ROW_COUNT) {
		if (
			lines[MAX_COHORT_LABEL_ROW_COUNT - 1].length >= MAX_COHORT_LABEL_ROW_LENGTH ||
			lines.length > MAX_COHORT_LABEL_ROW_COUNT
		) {
			lines[MAX_COHORT_LABEL_ROW_COUNT - 1] = lines[MAX_COHORT_LABEL_ROW_COUNT - 1].slice(0, 7) + "...";
		}
		lines = lines.slice(0, 3);
	}
	return lines;
};
